const API = {
  TOKEN: {
    ACCESS: `api/token/`,
    REFRESH: `api/token/refresh/`
  },
  ROLES: {
    INDEX: `roles/`
  },
  CORE: {
    PROJECTS: {
      INDEX: `projects/`
    },
    PROJECT_USERS: {
      INDEX: `project_users/`
    },
    USERS: {
      INDEX: `users/`,
      CURRENT_USER: `users/current_user/`
    }
  },
  CALCULATION: {
    INDEX: `calculations/`,
    DUPLICATE: (id: number) => `calculations/${id}/duplicate/`,
    RUN_CALCULATION: (id: number) => `calculations/${id}/run/`,
    RESET_CALCULATION: (id: number) => `calculations/${id}/reset/`,
    VALIDATE_SWITCH_DATABASE: (id: number) => `calculations/${id}/validate_switch_database/`,
    CHART_CONFIGURATIONS: {
      INDEX: `chart_configurations/`
    },
    QUANTITIES: {
      INDEX: `quantities/`,
      IMPORT_EXCEL: 'quantities/import-excel/'
    },
    QUANTITY_BUILDING_BLOCKS: {
      INDEX: `quantity_building_blocks/`
    },
    QUANTITY_CODES: {
      INDEX: `quantity_codes/`
    },
    TRANSPORT_CONFIGS: {
      INDEX: `transport_configs/`
    },
    RESULTS: {
      INDEX: `results/`,
      EXPORT_EXCEL: (calculationId: number) => `results/export-excel/?calculation=${calculationId}`
    }
  },
  BUILDING_BLOCK: {
    EQUIPMENT_FACTORS: {
      INDEX: `equipment_factors/`
    },
    BUILDING_BLOCKS: {
      INDEX: `building_blocks/`,
      DUPLICATE: (id: number) => `building_blocks/${id}/duplicate/`,
      CREATE_FROM_PRODUCT: `building_blocks/create_from_product/`
    },
    MATERIALS: {
      INDEX: `materials/`
    },
    ACTIVITIES: {
      INDEX: `activities/`
    },
    PRODUCTS: {
      INDEX: `products/`,
      IMPORT_EXCEL: 'products/import-excel/'
    },
    ENVIRONMENT_DATABASES: {
      INDEX: `environment_databases/`,
      USAGE: (id: number, excludeCalculation?: number) => {
        const query = new URLSearchParams()
        if (excludeCalculation) {
          query.set('exclude_calculation', String(excludeCalculation))
        }
        const queryString = query.toString()
        return `environment_databases/${id}/usage/${queryString ? `?${queryString}` : ''}`
      },
      DELETE: (id: number, excludeCalculation?: number) => {
        const query = new URLSearchParams()
        if (excludeCalculation) {
          query.set('exclude_calculation', String(excludeCalculation))
        }
        const queryString = query.toString()
        return `environment_databases/${id}/${queryString ? `?${queryString}` : ''}`
      }
    }
  }
}

export default API
